import { render, staticRenderFns } from "./homeFooter.vue?vue&type=template&id=05e6cf8c&scoped=true"
import script from "./homeFooter.vue?vue&type=script&lang=js"
export * from "./homeFooter.vue?vue&type=script&lang=js"
import style0 from "./homeFooter.vue?vue&type=style&index=0&id=05e6cf8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e6cf8c",
  null
  
)

export default component.exports